import { BordButton, BordIlustrationIcon } from 'bord-design-system';
import './MarkAsCtoModalContent.scss';

interface IMarkAsCtoModalContent {
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * Contenido del modal de confirmación para marcar una herramienta como CTO.
 * Muestra el ícono de advertencia, descripción del impacto y botones de acción.
 */
const MarkAsCtoModalContent = ({ onClose, onConfirm }: IMarkAsCtoModalContent) => {
  return (
    <div className="markAsCtoModalContent">
      <BordIlustrationIcon variant="warning" standardSize={64} />
      <h2 className="title">Marcar como CTO</h2>
      <div className="description">
        Al marcar como CTO, se ampliará el tiempo del SLA y se informará al cliente sobre esta modificación.
      </div>
      <div className="actions">
        <BordButton
          label="Cancelar"
          onClick={onClose}
          bordButtonStyle="outlined"
          modeButton="primary"
          customWidth="w-180"
        />
        <BordButton
          label="Marcar como CTO"
          onClick={onConfirm}
          bordButtonStyle="filled"
          modeButton="primary"
          customWidth="w-180"
        />
      </div>
    </div>
  );
};

export default MarkAsCtoModalContent;
